// reducer.js
import {
  SET_VALUE_Pexpl,
  SET_TYPE_Pexpl,
  SET_CURRENT_PAGE_Pexpl,
  SET_ORDER_Pexpl,
  SET_SORT_FIELD_Pexpl,
  SET_ACTIF_Pexpl,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "asc",
  sortField: "nom",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_Pexpl:
      return {
        ...state,
        value: action.payload,
      };
    case SET_TYPE_Pexpl:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_Pexpl:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_Pexpl:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_Pexpl:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_Pexpl:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
